import type { CSSProperties } from 'react';
import { T } from '@territory/tokens';
export type RemixFieldVariant = 'remix' | 'remix-editor' | 'remix-url' | 'remix-number';
const role = (name: string, fallback: string): string => `var(--rv-remix-tool-${name}, ${fallback})`;
/* Exact native field looks shared by the live tool in Marketing and remix-site. */
export function remixFieldStyle(variant: RemixFieldVariant | 'select'): CSSProperties {
  const compact = variant === 'select' || variant === 'remix-number';
  const url = variant === 'remix-url';
  return {
    ...(compact ? null : { width: '100%' }),
    ...(variant === 'remix-editor' ? { display: 'block', marginTop: 6 } : null),
    background: url ? 'transparent' : role('bg', T.bg),
    border: url ? 'none' : `1px solid ${role('edge', T.separator)}`,
    borderRadius: compact || variant === 'remix-editor' ? 10 : 12,
    padding: url ? '12px 6px' : compact ? '9px 10px' : variant === 'remix-editor' ? '10px 12px' : '13px 15px',
    color: role('ink', T.label), fontFamily: role(variant === 'remix-number' ? 'mono' : 'font', variant === 'remix-number' ? T.mono : T.font),
    fontSize: compact ? 13 : variant === 'remix-editor' ? 14 : 15,
    outline: 'none', transition: `border-color .2s ${role('ease', T.ease)}, box-shadow .2s ${role('ease', T.ease)}`,
    ...(compact ? { cursor: 'pointer' } : null),
    ...(url ? { boxShadow: 'none' } : null),
  };
}
export const REMIX_FIELD_CSS = `[data-rv-remix-field]:not([data-rv-remix-field="remix-url"]):focus { border-color: ${role('focus-edge', T.accent)} !important; box-shadow: 0 0 0 3px ${role('focus-ring', T.accentTint)}; }
input[data-rv-remix-field]::placeholder { color: ${role('placeholder', T.labelQuad)}; }`;
